export interface ActivityLogEntry {
  id: number;
  status: string;
  updatedAt: string;
}

interface GetProcessingEndLogParams {
  /** The full activity log, sorted ascending by id. */
  sortedActivityLog: ActivityLogEntry[];
  /** The processing-start entry being rendered. */
  startLog: ActivityLogEntry;
  /** The status that closes this processing window. */
  endStatus: string;
}

/**
 * Pairs a processing-start entry with the first matching end entry that follows it.
 *
 * A status can appear more than once (the revert-completed-order flow inserts rather than
 * updates), so scanning for the first match anywhere could pair a start with an unrelated end.
 * The comparison is strict, so an endStatus equal to the start's own status resolves to the next
 * occurrence rather than collapsing onto the start.
 */
export const getProcessingEndLog = ({
  sortedActivityLog,
  startLog,
  endStatus,
}: GetProcessingEndLogParams): ActivityLogEntry | undefined =>
  sortedActivityLog.find((log) => log.status === endStatus && log.id > startLog.id);
